import { render, staticRenderFns } from "./CompanyDirectors.vue?vue&type=template&id=6059c690&scoped=true&"
import script from "./CompanyDirectors.vue?vue&type=script&lang=js&"
export * from "./CompanyDirectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6059c690",
  null
  
)

export default component.exports